import { useState } from 'react';
import { useMemoizedFn } from 'ahooks';

export default function useSearchGenres() {
  const [keywords, setKeywords] = useState('');

  const handleSearch = useMemoizedFn((keywords?: string) => {
    const keywordsTmp = keywords || '';
    setKeywords(keywordsTmp);
  });

  const handleReset = useMemoizedFn(() => {
    setKeywords('');
  });

  return {
    keywords,
    onSearch: handleSearch,
    onReset: handleReset,
  };
}
